<div class="MainContainer">
  <app-tabs
    [initialTabIndex]="currentPathIndex"
    (tabChange)="onTabSelectionChange($event)"
  >
    <!--Overview-->
    <app-tab title="Overview">
      <span class="first-tab"></span>
      <app-overview></app-overview>
    </app-tab>
    <!--Tracking-->
    <app-tab title="Tracking">
      <app-tracking></app-tracking>
    </app-tab>
    <!--Telematics-Map-->
    <app-tab title="Telematics" id="Telematics">
      @if (selectedTab === "Telematics") {
        <app-telematics-map [rideData]="rideData"></app-telematics-map>
      }
    </app-tab>
    <app-tab title="GPS Connectivity Map" id="gps">
      @if (selectedTab === "GPS Connectivity Map") {
        <app-gps-connectivity-map></app-gps-connectivity-map>
      }
    </app-tab>
  </app-tabs>
</div>
